import clsx from "clsx";

export interface MaintenanceProgressBarProps {
  completed: number;
  total: number;
  /** Optionaler Text links (z. B. „12/40 Objekte“). */
  countLabel?: string;
  className?: string;
}

export function MaintenanceProgressBar({
  completed,
  total,
  countLabel,
  className,
}: MaintenanceProgressBarProps) {
  const safeTotal = Math.max(0, total);
  const safeCompleted = Math.min(Math.max(0, completed), safeTotal);
  const fraction = safeTotal > 0 ? safeCompleted / safeTotal : 0;
  const percent = Math.round(fraction * 100);
  const isComplete = safeTotal > 0 && safeCompleted >= safeTotal;

  if (safeTotal <= 0) {
    return (
      <p className={clsx("text-xs text-label-secondary", className)}>Noch keine Objekte</p>
    );
  }

  return (
    <div className={clsx("space-y-1", className)}>
      <div className="flex items-center justify-between gap-2 text-xs">
        <span className="text-label-secondary">
          {countLabel ?? `${safeCompleted}/${safeTotal} Objekte`}
        </span>
        <span className={clsx("font-semibold tabular-nums", isComplete ? "text-status-green" : "text-label-secondary")}>
          {percent} %
        </span>
      </div>
      <div
        className="h-1.5 overflow-hidden rounded-full bg-fill-tertiary"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={percent}
        aria-label={`Fortschritt ${percent} Prozent`}
      >
        <div
          className={clsx(
            "h-full rounded-full transition-[width]",
            isComplete ? "bg-status-green" : "bg-accent",
          )}
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
}
